import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import Detail from "../../main/detail/Detail";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseMyPC } from "../../hooks/UseMyPC";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useEffect, useState } from "react";
import ProgressCom from "../../components/ProgressCom";
import CustomPagination from "../../components/CustomPagination";
import { UseFractionalList } from "./UseFractionalList";
import { useLocation } from "react-router-dom";
import { toMoney } from "../../util/Utils";
import OrderDetail from "./OrderDetail";
import { useSnackbar } from "notistack";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";

export default function FractionalOrders() {
  const location = useLocation();

  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { myPc, goToFirstPage, updatePage, updateSort, setScrollTo, refresh } =
    UseMyPC();
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : "",
  );
  const { enqueueSnackbar } = useSnackbar();

  const [fractionalList, setFractionalList] = useState();
  const { getFractionalByDate, addAllOrderMissing, addOneOrderMissing } =
    UseFractionalList();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [isFractional, setIsFractional] = useState(true);
  const [orderCount, setOrderCount] = useState(50);
  const [openAllDialog, setOpenAllDialog] = useState(false);
  const [openDetails, setOpenDetails] = useState({
    show: false,
    orderId: null,
  });

  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
    orderId: null,
  });

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    if (location.state && location.state.date) {
      setProgress(true);
      getFractionalByDate(
        myPc,
        location.state.date,
        isFractional ? "t" : "",
        (fractionas) => {
          setFractionalList(fractionas);
        },
      );
    }
  }, [myPc, isFractional, location.state]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "id",
      width: 100,
      align: "center",
      headerName: "سفارش",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setScrollTo(cellValues.api.getScrollPosition());
            }}
            variant="span"
            sx={{
              direction: "ltr",
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {cellValues.row.id}
          </Typography>
        );
      },
    },
    {
      field: "ShamsiLogDate",
      headerName: "تاریخ",
      width: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setScrollTo(cellValues.api.getScrollPosition());
            }}
            variant="span"
            sx={{
              direction: "rtl",
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {cellValues.row.shamsiLogDate}
          </Typography>
        );
      },
    },
    {
      field: "fullName",
      headerName: "نام و نام خانوادگی",
      width: 170,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setScrollTo(cellValues.api.getScrollPosition());
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "start",
              display: "flex",
              alignItems: "center",
            }}
          >
            {cellValues.row.fullName}
          </Typography>
        );
      },
    },
    {
      field: "mobile",
      headerName: "موبایل",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setScrollTo(cellValues.api.getScrollPosition());
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {cellValues.row.mobile}
          </Typography>
        );
      },
    },
    {
      field: "payment",
      headerName: "نوع خرید",
      width: 120,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setScrollTo(cellValues.api.getScrollPosition());
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            {cellValues.row.payment}
          </Typography>
        );
      },
    },
    {
      field: "totalPayment",
      headerName: "قیمت",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setScrollTo(cellValues.api.getScrollPosition());
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "left",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {cellValues.row.totalPayment
              ? toMoney(cellValues.row.totalPayment)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "state",
      headerName: "وضعیت",
      width: 140,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setScrollTo(cellValues.api.getScrollPosition());
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            {cellValues.row.state}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 100,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return cellValues.row.fractional == true ? (
          <Button
            onClick={() => {
              setCheckState({
                show: true,
                name: "افزودن سفارش به لیست کسری",
                orderId: cellValues.row.id,
              });
            }}
            variant="contained"
            color="secondary"
          >
            افرودن
          </Button>
        ) : (
          ""
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "سفارشات",
        backButtonDef: true,
        backURL: "/fractionallist",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/fractionallist",
          },
          {
            name: "سفارشاتس",
            url: "/fractionallist/orders",
          },
        ],
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setIsFractional(!isFractional)}
          >
            {isFractional ? "نمایش همه" : "نمایش جامانده ها"}
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => {
              setOrderCount(50);
              setOpenAllDialog(!openAllDialog);
            }}
          >
            افزودن همه
          </Button>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          {fractionalList ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              rows={fractionalList.orders ?? []}
              paginationMode="server"
              page={fractionalList.pageCondition.page - 1}
              pageSize={fractionalList.pageCondition.pageCount}
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={fractionalList.pageCondition.totalItemCount}
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc",
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
              componentsProps={{
                pagination: {
                  scrollTo: myPc.scrollTo,
                  isLtr: true,
                  nofab: true,
                  rowCount:
                    fractionalList &&
                    fractionalList.pageCondition.totalItemCount
                      ? fractionalList.pageCondition.totalItemCount
                      : "",
                },
              }}
              sx={{
                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },
                "&  .MuiDataGrid-columnHeader:focus-within": {
                  outline: "none",
                },
                "&  .MuiDataGrid-cell:focus-within ": {
                  outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                },
                "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
                  {
                    outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                  },
                "& .MuiDataGrid-cell:hover": {
                  opacity: "80%",
                  cursor: "pointer",
                },
                "& .MuiDataGrid-virtualScrollerRenderZone": {
                  width: "100% !important",
                },
                "& .white": {
                  backgroundColor: "#ffffff !important",
                },
                "& .red": {
                  backgroundColor: "#ff9c9c !important",
                },
              }}
              getRowClassName={(params) => {
                if (params.row.fractional == true) {
                  return "red";
                }
              }}
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </Box>
      </Box>
      <Dialog open={openAllDialog} onClose={() => setOpenAllDialog(false)}>
        <DialogTitle sx={{ color: "red" }}>توجه!</DialogTitle>
        <DialogContent
          sx={{ display: "flex", flexDirection: "column", gap: 3 }}
        >
          <DialogContentText id="alert-dialog-description">
            لطفا تعداد سفارشات مورد نظر خود را جهت افرودن به لیست کسری وارد
            کنید.
          </DialogContentText>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <TextField
              sx={{
                input: {
                  textAlign: "center",
                },
              }}
              type="number"
              InputProps={{
                inputProps: {
                  min: 1,
                },
              }}
              label="تعداد"
              value={orderCount}
              onChange={(e) => setOrderCount(e.target.value)}
            />
            <Button
              variant="contained"
              onClick={() => {
                if (!orderCount || orderCount <= 0) {
                  enqueueSnackbar("تعداد نامعتبر", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }

                let requestModel = {
                  limit: orderCount,
                  date: location.state.date,
                };
                setProgress(true);
                addAllOrderMissing(requestModel, () => {
                  setOpenAllDialog(false);
                  refresh();
                });
              }}
            >
              افزودن
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      {openDetails.show && (
        <OrderDetail
          open={openDetails}
          setOpen={setOpenDetails}
          orderID={openDetails.orderId}
        />
      )}
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          let requestModel = {
            OrderID: checkState.orderId,
          };
          setProgress(true);
          addOneOrderMissing(requestModel, () => {
            refresh();
            setCheckState({ show: false });
          });
        }}
      />
    </Detail>
  );
}
